import React from 'react'

export const Footer = () => {
  return (
    <div>
        <div className="copyright shadows mt-3" style={{borderRadius: '5px'}}>
      <span className='text-dark pt-4 ps-3'>© 2024 Copyright CDAT Pune. All Rights Reserved.</span>
            </div>
    </div>
  )
}
